export default __webpack_public_path__ + "static/media/QV_Spaghetti.2e8e1333.jpg";